export default "__VITE_ASSET__48f0f223__"